import React, { useEffect, useState } from "react";
import InputField from "./input-field";
import FileContainer from "./file-container";
import TextAreaField from "./text-area";

function PurchaseRequisition({
  onRemove,
  onAdd,
  id,
  itemIndex = 0,
  handleTotalCostChange,
  updateRequisition,
}) {
  const [currentQuantity, setQuantity] = useState(0);
  const [currentPrice, setPrice] = useState(0);
  const [estimatedCost, setEstimatedCost] = useState(0);
  const [attachmentPreview, setAttachmentPreview] = useState([]);
  const [attachmentData, setAttachmentData] = useState([]);

  const [filePreview, setFilePreview] = useState([]);
  const [fileData, setFileData] = useState([]);

  const [description, setDescription] = useState("");
  const [remarks, setRemarks] = useState("");


  useEffect(() => {
    const cost =
      (parseFloat(currentPrice) || 0) * (parseFloat(currentQuantity) || 0);
    setEstimatedCost(cost);
  }, [currentPrice, currentQuantity]);

  const handleOnChange = (fieldName, eventTarget) => {
    let value = "";
    if (fieldName === "Description" || fieldName === "Remarks") {
      value = eventTarget.value;
    } else {
      value = parseFloat(eventTarget.value) || 0;
    }
    if (fieldName === "Quantity") {
      setQuantity(value);
    } else if (fieldName === "Estimated Price") {
      setPrice(value);
    } else if (fieldName === "Description") {
      setDescription(value);
    } else if (fieldName === "Remarks") {
      setRemarks(value);
    }
  };

  const handleAttachmentChange = (event, key) => {
    const files = event.target.files;

    const newFilePreviews = [];
    const newSelectedFiles = [];

    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const fileSizeMB = files[i].size / 1024 / 1024;

        const objProperty = {
          filePreview: URL.createObjectURL(files[i]),
          file: files[i],
          type: files[i].type,
          size: fileSizeMB,
        };
        newSelectedFiles.push(objProperty);
        newFilePreviews.push(objProperty);
      }
      if (key === "attachment") {
        setAttachmentData(newSelectedFiles);
        setAttachmentPreview(newFilePreviews);
      }
      if (key === "file") {
        setFileData(newSelectedFiles);
        setFilePreview(newFilePreviews);
      }
    }
  };

  const handleAttachmentRemove = (filePreviewUrl, key) => {
    if (key === "attachment") {
      setAttachmentPreview(
        attachmentPreview.filter((file) => file.filePreview !== filePreviewUrl),
      );
      setAttachmentData(
        attachmentData.filter((file) => file.filePreview !== filePreviewUrl),
      );
    }

    if (key === "file") {
      setFileData(
        fileData.filter((file) => file.filePreview !== filePreviewUrl),
      );
      setFilePreview(
        filePreview.filter((file) => file.filePreview !== filePreviewUrl),
      );
    }
  };

  // const handleStructurePurchase = () => {
  //   const structure = {
  //     id: id,
  //     description: description,
  //     remarks: remarks,
  //     quantity: currentQuantity,
  //     price: currentPrice,
  //     cost: estimatedCost,
  //     attachment: attachmentData,
  //     file: fileData,
  //   };

  //   updateRequisition(structure);
  // };

  const handleStructurePurchase = () => {
    const computedCost =
      (parseFloat(currentPrice) || 0) * (parseFloat(currentQuantity) || 0);

    const structure = {
      id,
      description,
      remarks,
      quantity: currentQuantity,
      price: currentPrice,
      cost: computedCost,
      attachment: attachmentData,
      file: fileData,
    };

    updateRequisition(structure);
  };

  useEffect(() => {
    handleStructurePurchase();
  }, [
    description,
    remarks,
    currentQuantity,
    currentPrice,
    estimatedCost,
    attachmentData,
    fileData,
  ]);

  return (
    <div className="purchase-requisition-whole-row" id={`pr-${id}`}>
      <div className="purchase-requisition-header">
        <div>
          <span className="purchase-requisition-header__eyebrow">Line Item {itemIndex + 1}</span>
          <h5>Requested Product or Service</h5>
        </div>

        <div className="field-action">
          <button type="button" className="epr-icon-btn" onClick={() => onAdd()} title="Add line item">
            <i className="fa fa-plus-circle" aria-hidden="true"></i>
            <span>Add</span>
          </button>
          <button
            type="button"
            className="epr-icon-btn epr-icon-btn--danger"
            onClick={() => {
              onRemove(id);
              handleTotalCostChange();
            }}
            title="Remove line item"
          >
            <i className="fa fa-trash" aria-hidden="true"></i>
            <span>Remove</span>
          </button>
        </div>
      </div>

      <div className="purchase--fields purchase--fields--grid-two">
        <TextAreaField
          fieldName={"Description"}
          required={true}
          handleOnChange={handleOnChange}
          value={description}
        />

        <TextAreaField
          fieldName={"Remarks"}
          required={false}
          handleOnChange={handleOnChange}
          value={remarks}
        />
      </div>

      <div className="purchase--fields purchase--fields--metrics">
        <InputField
          fieldName={"Quantity"}
          required={true}
          handleOnChange={handleOnChange}
          value={currentQuantity}
        />

        <InputField
          fieldName={"Estimated Price"}
          required={false}
          handleOnChange={handleOnChange}
          value={currentPrice}
        />

        <div className="fields fields--highlight">
          <span className="field-name">Estimated Cost</span>
          <input
            type="number"
            className="estimated-cost"
            data-value={estimatedCost}
            value={estimatedCost}
            readOnly
          />
        </div>
      </div>

      <div className="purchase--fields purchase--fields--grid-two">
        <div className="fields epr-upload-block">
          <span className="field-name">Attachments</span>
          <div className="files-attachment-container">
            <div className="files-attachment-input">
              <input
                type="file"
                onChange={(e) => handleAttachmentChange(e, "attachment")}
                multiple
              />
            </div>
            <div className="files-upload-container">
              {attachmentPreview.map((attachment, index) => (
                <FileContainer
                  attachment={attachment}
                  key={index}
                  handleAttachmentRemove={handleAttachmentRemove}
                  removeKey={"attachment"}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="fields epr-upload-block">
          <span className="field-name">Supporting Files</span>
          <div className="files-attachment-container">
            <div className="files-attachment-input">
              <input
                type="file"
                onChange={(e) => handleAttachmentChange(e, "file")}
                multiple
              />
            </div>
            <div className="files-upload-container">
              {filePreview.map((attachment, index) => (
                <FileContainer
                  attachment={attachment}
                  key={index}
                  handleAttachmentRemove={handleAttachmentRemove}
                  removeKey={"file"}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PurchaseRequisition;
